<template>
  <div class="container-fluid bg-white container-fluid px-4 py-5 rounded-4 contenedor-principal">
    <inmuebles-grid />
  </div>
</template>

<script setup lang="ts">
import InmueblesGrid from "@/components/inmuebles/InmueblesGrid.vue";
import { useComunicadosPortalSinLeer } from "@/composables/useComunicadosPortalSinLeer";

useComunicadosPortalSinLeer();
</script>